import { KnownIssueModel } from "@doitintl/cmp-models";
import { type DocumentSnapshotModel, getCollection } from "@doitintl/models-any";

import { type KnownIssue } from "../KnownIssues/types";

export const observeKnownIssueData = (
  id: KnownIssue["id"],
  onSnapshotCallback: (docSnapshot: DocumentSnapshotModel<KnownIssueModel>) => void
) => getCollection(KnownIssueModel).doc(id).onSnapshot(onSnapshotCallback);
